import { combineReducers } from "@reduxjs/toolkit";
import { authSlice, ewayBillFilterSlice, lrFilterSlice, pageSlice, tripSlice } from "features";
import { ewayCheckerFilterSlice } from "features/ewayCheckerFilterServices";
import lrSearchSlice from "features/lrFilterServices/lrSearchSlice";
import { planFilterSlice } from "features/PlanFilterService";
import { tripFilterSlice } from "features/tripFilterService";

const rootReducer = combineReducers({
  auth: authSlice,
  page: pageSlice,
  trip: tripSlice,
  lrFilter: lrFilterSlice,
  ewayBillFilter: ewayBillFilterSlice,
  ewayChecker: ewayCheckerFilterSlice,
  lrSearch: lrSearchSlice,
  tripFilter:tripFilterSlice,
  planFilter:planFilterSlice
  // Add additional reducers here
});

export default rootReducer;
